import { createFileRoute, redirect } from '@tanstack/react-router'
import { UserData } from '@/types/userTypes'

export const Route = createFileRoute('/callback')({
  component: CallbackComponent,
  loader: async ({ context }) => {
    // The backend has just set an HttpOnly session cookie. Read our identity
    // back from /me — no user data is passed through the URL anymore.
    let response: Response
    try {
      response = await fetch('/api/me', { credentials: 'same-origin' })
    } catch {
      throw redirect({ to: '/authentication' })
    }

    if (!response.ok) {
      throw redirect({ to: '/authentication' })
    }

    const user = (await response.json()) as UserData
    context.userStore.setState(user)
    throw redirect({ to: '/' })
  },
})

function CallbackComponent() {
  return (
    <div className="flex h-full items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4 text-muted-foreground">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-border border-t-primary" />
        <p className="text-sm">Signing you in…</p>
      </div>
    </div>
  )
}

export default CallbackComponent
